import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Reusable scroll-reveal: fades and lifts content into view once.
export const Reveal = ({ children, delay = 0, y = 24, className = "", as = "div", ...rest }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10%" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

// Staggered container + items for lists/grids.
export const StaggerGroup = ({ children, className = "", stagger = 0.08, ...rest }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-10%" }}
    variants={{
      hidden: {},
      show: { transition: { staggerChildren: stagger } },
    }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 24, ...rest }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE } },
    }}
    {...rest}
  >
    {children}
  </motion.div>
);
